import { useEffect, useRef } from 'react';

// Pointer-tracked glass highlight (--mx/--my) plus optional 3D tilt
// (--rx/--ry, clamped to ~7deg), gated to fine pointers with hover support.
export function useTilt({ tilt = false } = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const move = (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      const y = (e.clientY - r.top) / r.height;
      el.style.setProperty('--mx', x * 100 + '%');
      el.style.setProperty('--my', y * 100 + '%');
      if (fine && tilt) {
        const k = Math.min(7, 1800 / Math.max(r.width, 200));
        el.style.setProperty('--rx', ((0.5 - y) * k).toFixed(2) + 'deg');
        el.style.setProperty('--ry', ((x - 0.5) * k).toFixed(2) + 'deg');
      }
    };
    const leave = () => {
      el.style.setProperty('--rx', '0deg');
      el.style.setProperty('--ry', '0deg');
    };

    el.addEventListener('pointermove', move);
    el.addEventListener('pointerleave', leave);
    return () => {
      el.removeEventListener('pointermove', move);
      el.removeEventListener('pointerleave', leave);
    };
  }, [tilt]);

  return ref;
}
